/* Print & Frame Online — configurator
   Loaded by sections/dpf-print-frame.liquid. No Liquid in this file.
   All data arrives in JSON script tags rendered by the section:
     #pfo-config    settings, band table, surface and finish maps
     #pfo-products  live variant ids and prices, straight from Shopify
     #pfo-textures  timber strip images as data URIs
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-pfo]');
  if (!root) return;

  function jsonFrom(id) {
    var el = document.getElementById(id);
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  var CFG = jsonFrom('pfo-config');
  var PRODUCTS = jsonFrom('pfo-products') || {};
  var TEX = jsonFrom('pfo-textures') || {};
  if (!CFG) return;

  var $ = function (sel) { return root.querySelector(sel); };

  /* ---------------------------------------------------------------- model */

  var BANDS = CFG.bands;                       // [[w,h], ...] in band order
  var LIMITS = CFG.limits;                     // {minSide, maxShort, maxLong}
  var QUALITY = CFG.quality;                   // {high, block:{medium:dpi}}
  var MEDIA = CFG.media;                       // [{id, label, group, finishes:[...]}]
  var FRAMES = CFG.frames;                     // [{id, label, tex}]
  var BORDERS = CFG.borders;                   // [0,30,50,70]
  var FLOAT_FACE = CFG.floatFace;              // 10
  var FLOAT_GAP = CFG.floatGap;                // 5
  var CANVAS_DEPTH = CFG.canvasDepth;          // 38
  var UPLOAD = CFG.uploadEndpoint || '';       // blank = preview mode, no cart
  // Share of the screen the sticky preview may take. Set in the customizer.
  var DISPATCH = CFG.dispatchNote || '';       // shown beside the price
  var PREV_M = (CFG.previewHeightMobile || 40) / 100;
  var PREV_D = (CFG.previewHeightDesktop || 60) / 100;

  var FINISH_LABEL = {
    'rolled': 'Unframed',
    'stretched': 'Stretched',
    'float-frame': 'Framed',
    'paper-frame': 'Framed'
  };

  // One line under the Finish chips, describing what actually arrives.
  var FINISH_NOTE = {
    'rolled': 'Rolled in a tube, ready to frame yourself',
    'stretched': 'Stretched over NZ pine stretchers, wire attached, ready to hang',
    'float-frame': 'Stretched and set in a timber float frame, wire attached, ready to hang',
    'paper-frame': 'Quality paper framed behind glass, wire attached, ready to hang'
  };

  var S = {
    medium: MEDIA[0].id,
    finish: 'float-frame',
    frame: FRAMES[0].id,
    w: 600, h: 750,
    border: 0, borderCustom: false,
    zoom: 1, ox: 0.5, oy: 0.5, rot: 0,
    ack: false,
    unit: 'mm',                              // display only, never leaves the screen
    img: null, imgName: '', srcPx: [0, 0],
    file: null,
    fileToken: '', uploadState: 'none', uploadPct: 0,
    adding: false
  };

  /* ----------------------------------------------------------------- units */
  // Sizes are held in mm everywhere: bands, pricing, the crop maths and every
  // _dpf_ property. The unit toggle only changes what is drawn on screen.

  function toDisp(mm) { return S.unit === 'cm' ? mm / 10 : mm; }
  function toMm(v) { return Math.round(S.unit === 'cm' ? v * 10 : v); }
  function dispNum(mm) { return String(Math.round(toDisp(mm) * 10) / 10); }
  function dispSize(w, h) { return dispNum(w) + ' × ' + dispNum(h) + ' ' + S.unit; }

  function syncSizeInputs() {
    var w = $('.pfo-w'), h = $('.pfo-h');
    w.value = dispNum(S.w);
    h.value = dispNum(S.h);
    [w, h].forEach(function (el) {
      el.step = S.unit === 'cm' ? '0.1' : '1';
      el.min = dispNum(LIMITS.minSide);
      el.max = dispNum(LIMITS.maxLong);
      el.setAttribute('inputmode', S.unit === 'cm' ? 'decimal' : 'numeric');
    });
  }

  function syncBorderInput() {
    var cb = $('.pfo-cb');
    cb.value = dispNum(S.border || 50);
    cb.step = S.unit === 'cm' ? '0.1' : '1';
    cb.min = dispNum(5);
    cb.max = dispNum(300);
    cb.setAttribute('inputmode', S.unit === 'cm' ? 'decimal' : 'numeric');
    $('.pfo-cb-unit').textContent = S.unit;
  }

  function medium() {
    for (var i = 0; i < MEDIA.length; i++) if (MEDIA[i].id === S.medium) return MEDIA[i];
    return MEDIA[0];
  }
  function isPaper() { return medium().group === 'paper'; }
  function isCanvas() { return medium().group === 'canvas'; }
  function frameDef(id) {
    for (var i = 0; i < FRAMES.length; i++) if (FRAMES[i].id === (id || S.frame)) return FRAMES[i];
    return FRAMES[0];
  }

  /* ------------------------------------------------------------- products */
  // Which product handle serves the current combination.
  function handleFor() {
    var g = medium().group;                    // canvas | paper
    if (S.finish === 'rolled') return 'pfo-' + g + '-rolled';
    if (S.finish === 'stretched') return 'pfo-canvas-stretched';
    return 'pfo-' + g + '-framed-' + S.frame;
  }
  function bandIndex(w, h) {
    var per = 2 * (w + h), area = w * h;
    for (var i = 0; i < BANDS.length; i++) {
      if (2 * (BANDS[i][0] + BANDS[i][1]) >= per && BANDS[i][0] * BANDS[i][1] >= area) return i;
    }
    return -1;
  }
  function bandCode(i) { return 'Band ' + (i + 1 < 10 ? '0' : '') + (i + 1); }
  function variantFor() {
    var p = PRODUCTS[handleFor()];
    if (!p) return null;
    var i = bandIndex(S.w, S.h);
    if (i < 0) return null;
    var code = bandCode(i);
    for (var k = 0; k < p.variants.length; k++) {
      if (p.variants[k].b === code) return { id: p.variants[k].i, cents: p.variants[k].p, band: i, title: p.title };
    }
    return null;
  }

  /* ------------------------------------------------------------- geometry */

  function borderMm() { return isPaper() ? Math.max(0, S.border) : 0; }
  function printArea() { var b = borderMm(); return { w: S.w - 2 * b, h: S.h - 2 * b }; }
  function faceMm() {
    if (S.finish === 'float-frame') return FLOAT_FACE;
    if (S.finish === 'paper-frame') return (S.w * S.h / 1e6 > 1) ? 30 : 20;
    return 0;
  }
  function validSize() {
    var s = Math.min(S.w, S.h), l = Math.max(S.w, S.h), pa = printArea();
    return s >= LIMITS.minSide && s <= LIMITS.maxShort && l <= LIMITS.maxLong && pa.w >= 100 && pa.h >= 100;
  }
  function imgDims() { return (S.rot % 180) ? [S.srcPx[1], S.srcPx[0]] : [S.srcPx[0], S.srcPx[1]]; }
  function cropRect() {
    var pa = printArea(), d = imgDims(), iw = d[0], ih = d[1];
    var ar = pa.w / pa.h, ir = iw / ih, fw, fh;
    if (ir > ar) { fh = 1; fw = ar / ir; } else { fw = 1; fh = ir / ar; }
    fw /= S.zoom; fh /= S.zoom;
    return { x: (1 - fw) * S.ox, y: (1 - fh) * S.oy, w: fw, h: fh, iw: iw, ih: ih };
  }
  function dpi() {
    if (!S.img) return 0;
    var c = cropRect();
    return Math.round(c.w * c.iw / (printArea().w / 25.4));
  }
  // Quality for any candidate size, without touching the current selection.
  // Mirrors cropRect + dpi so one set of maths decides both.
  function qualityFor(w, h) {
    if (!S.img) return 'none';
    var b = borderMm();
    var paW = Math.max(1, w - 2 * b), paH = Math.max(1, h - 2 * b);
    var d = imgDims(), iw = d[0], ih = d[1];
    var ar = paW / paH, ir = iw / ih;
    var fw = (ir > ar ? ar / ir : 1) / S.zoom;
    var dp = Math.round(fw * iw / (paW / 25.4));
    var block = QUALITY.block[S.medium] || 60;
    if (dp < block) return 'low';
    if (dp < QUALITY.high) return 'medium';
    return 'high';
  }
  function qualityLevel() { return qualityFor(S.w, S.h); }

  /* ------------------------------------------ sizes that match the picture */

  function suggestSizes() {
    if (!S.img) return [];
    var d = imgDims(), iw = d[0], ih = d[1], port = ih >= iw, b = borderMm();
    var R = Math.max(iw, ih) / Math.min(iw, ih), out = [];
    [300, 400, 500, 600, 700, 800, 1000, 1200].forEach(function (s) {
      var ps = s - 2 * b; if (ps < 100) return;
      var l = Math.round((ps * R + 2 * b) / 10) * 10;
      if (s < LIMITS.minSide || s > LIMITS.maxShort || l > LIMITS.maxLong) return;
      var cand = port ? [s, l] : [l, s];
      // Never offer a size that would print badly.
      if (qualityFor(cand[0], cand[1]) === 'low') return;
      out.push(cand);
    });
    return out.slice(0, 6);
  }

  /* -------------------------------------------------------------- drawing */

  var cv = $('.pfo-canvas'), ctx = cv.getContext('2d');
  var texImg = {};
  Object.keys(TEX).forEach(function (k) {
    var im = new Image();
    im.onload = draw;
    im.src = TEX[k];
    texImg[k] = im;
  });

  // The timber strip is short, so a plain repeat shows a seam every tile along the
  // rail. Mirroring it end to end makes the repeat continuous.
  function texPattern(key, faceW, horizontal) {
    var im = texImg[key];
    if (!im || !im.complete || !im.naturalWidth) return '#8a7a6a';
    var w = Math.max(1, Math.round(faceW));
    var len = Math.max(1, Math.round(im.height * (faceW / im.width)));

    var v = document.createElement('canvas');
    v.width = w; v.height = len * 2;
    var gv = v.getContext('2d');
    gv.drawImage(im, 0, 0, w, len);
    gv.save();
    gv.translate(0, len * 2);
    gv.scale(1, -1);
    gv.drawImage(im, 0, 0, w, len);
    gv.restore();
    if (!horizontal) return ctx.createPattern(v, 'repeat');

    var hz = document.createElement('canvas');
    hz.width = len * 2; hz.height = w;
    var gh = hz.getContext('2d');
    gh.translate(0, w);
    gh.rotate(-Math.PI / 2);
    gh.drawImage(v, 0, 0);
    return ctx.createPattern(hz, 'repeat');
  }

  function drawImageInto(x, y, w, h) {
    if (!S.img) return;
    var c = cropRect();
    var srcW = S.img.width, srcH = S.img.height;
    var cw = (S.rot % 180) ? srcH : srcW, ch = (S.rot % 180) ? srcW : srcH;
    ctx.save();
    ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    ctx.translate(x + w / 2, y + h / 2);
    ctx.rotate(S.rot * Math.PI / 180);
    var rotated = S.rot % 180, dw = rotated ? h : w, dh = rotated ? w : h;
    var sx = c.x * cw, sy = c.y * ch, sw = c.w * cw, sh = c.h * ch;
    var rsx = sx, rsy = sy, rsw = sw, rsh = sh;
    if (S.rot === 90) { rsx = sy; rsy = cw - sx - sw; rsw = sh; rsh = sw; }
    else if (S.rot === 180) { rsx = cw - sx - sw; rsy = ch - sy - sh; }
    else if (S.rot === 270) { rsx = ch - sy - sh; rsy = sx; rsw = sh; rsh = sw; }
    ctx.drawImage(S.img, rsx, rsy, rsw, rsh, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }

  /* ------------------------------------------------------- sticky offset */
  // Height of whatever sticky or fixed header the theme puts above us, so the
  // preview pins under it rather than behind it. Measured, because themes name
  // that element half a dozen different ways.

  var HEADER = 0;

  function measureHeader() {
    var sels = ['sticky-header', '.section-header', '#shopify-section-header',
                'header.header', '.shopify-section-header-sticky'];
    HEADER = 0;
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (!el) continue;
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') continue;
      var h = Math.round(el.getBoundingClientRect().height);
      if (h > 0 && h < window.innerHeight * 0.4) { HEADER = h; break; }
    }
    root.style.setProperty('--pfo-top', HEADER + 'px');
  }

  function cssVar(name, fallback) {
    var v = getComputedStyle(root).getPropertyValue(name);
    return (v && v.trim()) || fallback;
  }

  // The live mm-to-screen-pixel scale from the last draw. Dragging uses it so
  // the picture keeps up with the finger whatever shape the box is.
  var PPM = 1;

  function draw() {
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var full = root.classList.contains('is-full');
    var mobile = window.innerWidth < 990;
    var cssW = cv.clientWidth || 360;
    var cssH;

    var face = faceMm(), gap = (S.finish === 'float-frame') ? FLOAT_GAP : 0;
    var outerW = S.w + 2 * (face + gap), outerH = S.h + 2 * (face + gap);

    if (full) {
      // Fullscreen: CSS stretches the canvas to fill the stage, so just read it.
      cssH = Math.max(160, cv.clientHeight || 400);
    } else {
      // The box takes the shape of the piece, so a portrait print fills the
      // width instead of sitting in a landscape box with empty sides.
      // The header eats into the usable height, so budget against what is left.
      var capH = Math.round((window.innerHeight - HEADER) * (mobile ? PREV_M : PREV_D));
      cssH = Math.max(200, Math.min(Math.round(cssW * (outerH / outerW)), capH));
      cv.style.height = cssH + 'px';
    }

    cv.width = Math.round(cssW * dpr);
    cv.height = Math.round(cssH * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    cv.classList.toggle('is-empty', !S.img);

    var W = cssW, H = cssH;
    var wall = cssVar('--pfo-wall', '#EFE3D3');
    var pad = full ? 18 : (mobile ? 14 : 28);
    var ppm = Math.min((W - 2 * pad) / outerW, (H - 2 * pad) / outerH);
    PPM = ppm;
    ctx.fillStyle = wall; ctx.fillRect(0, 0, W, H);
    var cx = W / 2, cy = H / 2;

    var OW = outerW * ppm, OH = outerH * ppm;
    var ox = cx - OW / 2, oy = cy - OH / 2;

    ctx.save();
    ctx.shadowColor = 'rgba(43,29,26,.35)';
    ctx.shadowBlur = Math.max(6, ppm * 30);
    ctx.shadowOffsetY = Math.max(3, ppm * 14);
    ctx.fillStyle = '#000';
    ctx.fillRect(ox, oy, OW, OH);
    ctx.restore();

    var fpx = face * ppm, gpx = gap * ppm;

    if (face > 0) {
      var key = (S.finish === 'float-frame' ? 'float-' : 'paper-') + frameDef().tex;
      var sides = [
        { pts: [[0, 0], [OW, 0], [OW - fpx, fpx], [fpx, fpx]], h: true },
        { pts: [[0, OH], [fpx, OH - fpx], [OW - fpx, OH - fpx], [OW, OH]], h: true },
        { pts: [[0, 0], [fpx, fpx], [fpx, OH - fpx], [0, OH]], h: false },
        { pts: [[OW, 0], [OW, OH], [OW - fpx, OH - fpx], [OW - fpx, fpx]], h: false }
      ];
      var shade = ['rgba(255,255,255,.10)', 'rgba(0,0,0,.18)', 'rgba(255,255,255,.04)', 'rgba(0,0,0,.10)'];
      sides.forEach(function (s, i) {
        ctx.save();
        ctx.translate(ox, oy);
        ctx.beginPath();
        s.pts.forEach(function (p, j) { j ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]); });
        ctx.closePath();
        ctx.clip();
        ctx.fillStyle = texPattern(key, Math.max(2, fpx), s.h);
        ctx.translate(i === 3 ? OW - fpx : 0, i === 1 ? OH - fpx : 0);
        ctx.fillRect(-OW, -OH, 3 * OW, 3 * OH);
        ctx.fillStyle = shade[i];
        ctx.fillRect(-OW, -OH, 3 * OW, 3 * OH);
        ctx.restore();
      });
      ctx.strokeStyle = 'rgba(0,0,0,.22)';
      ctx.lineWidth = 1;
      ctx.strokeRect(ox + 0.5, oy + 0.5, OW - 1, OH - 1);
    }

    if (gap > 0) {
      ctx.fillStyle = '#171110';
      ctx.fillRect(ox + fpx, oy + fpx, OW - 2 * fpx, OH - 2 * fpx);
    }

    var px = ox + fpx + gpx, py = oy + fpx + gpx, pw = S.w * ppm, ph = S.h * ppm;
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(px, py, pw, ph);

    var b = borderMm() * ppm;
    if (S.img) {
      drawImageInto(px + b, py + b, pw - 2 * b, ph - 2 * b);
    } else {
      ctx.fillStyle = 'rgba(43,29,26,.06)';
      ctx.fillRect(px + b, py + b, pw - 2 * b, ph - 2 * b);
      ctx.fillStyle = cssVar('--pfo-ink-soft', '#6B5D57');
      ctx.textAlign = 'center';
      ctx.font = '13px ' + cssVar('--pfo-body-font', 'sans-serif');
      ctx.fillText('Upload a picture to see it here', px + pw / 2, py + ph / 2);
      ctx.textAlign = 'start';
    }

    if (S.finish === 'paper-frame') {
      var g2 = ctx.createLinearGradient(px, py, px + pw, py + ph);
      g2.addColorStop(0, 'rgba(255,255,255,.16)');
      g2.addColorStop(0.45, 'rgba(255,255,255,0)');
      g2.addColorStop(1, 'rgba(255,255,255,.08)');
      ctx.fillStyle = g2;
      ctx.fillRect(px, py, pw, ph);
    }
    if (S.finish === 'rolled') {
      ctx.strokeStyle = 'rgba(0,0,0,.12)';
      ctx.strokeRect(px + 0.5, py + 0.5, pw - 1, ph - 1);
    }
  }

  /* ------------------------------------------------------------------- UI */

  function chip(label, isOn, onClick, extraHtml) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pfo-chip';
    b.setAttribute('aria-pressed', String(!!isOn));
    b.innerHTML = (extraHtml || '') + label;
    b.addEventListener('click', onClick);
    return b;
  }

  function renderSurface() {
    var c = $('.pfo-surface'); c.innerHTML = '';
    MEDIA.forEach(function (m) {
      c.appendChild(chip(m.label, m.id === S.medium, function () {
        var wasGroup = medium().group;
        S.medium = m.id;
        if (wasGroup !== medium().group) S.finish = isCanvas() ? 'float-frame' : 'paper-frame';
        renderSurface(); renderFinish(); update();
      }));
    });
  }

  function renderFinish() {
    var c = $('.pfo-finish'); c.innerHTML = '';
    medium().finishes.forEach(function (f) {
      c.appendChild(chip(FINISH_LABEL[f] || f, f === S.finish, function () {
        S.finish = f; renderFinish(); update();
      }));
    });

    var framed = S.finish === 'float-frame' || S.finish === 'paper-frame';
    $('.pfo-frame-head').hidden = !framed;
    $('.pfo-frame').hidden = !framed;
    if (framed) {
      var pre = S.finish === 'float-frame' ? 'float-' : 'paper-';
      var fc = $('.pfo-frame'); fc.innerHTML = '';
      FRAMES.forEach(function (f) {
        var sw = '<span class="pfo-sw" style="background-image:url(' + (TEX[pre + f.tex] || '') + ')"></span>';
        fc.appendChild(chip(f.label, f.id === S.frame, function () {
          S.frame = f.id; renderFinish(); update();
        }, sw));
      });
    }

    $('.pfo-finish-note').textContent = FINISH_NOTE[S.finish] || '';

    var paper = isPaper();
    $('.pfo-border-step').hidden = !paper;
    if (!paper) { S.border = 0; S.borderCustom = false; $('.pfo-cbrow').hidden = true; }
    if (paper) renderBorders();
  }

  function renderBorders() {
    var c = $('.pfo-border'); c.innerHTML = '';
    BORDERS.forEach(function (v) {
      c.appendChild(chip(v === 0 ? 'No border' : dispNum(v) + ' ' + S.unit, !S.borderCustom && S.border === v, function () {
        S.borderCustom = false; S.border = v; syncBorderInput(); renderBorders(); update();
      }));
    });
    c.appendChild(chip('Custom', S.borderCustom, function () {
      S.borderCustom = true;
      S.border = toMm(parseFloat($('.pfo-cb').value) || 0) || 50;
      renderBorders(); update();
    }));
    $('.pfo-cbrow').hidden = !S.borderCustom;
  }

  function renderPresets() {
    var list = suggestSizes(), c = $('.pfo-presets');
    c.innerHTML = '';
    $('.pfo-preset-note').hidden = !list.length;
    if (!list.length) return;
    var biggest = list.reduce(function (m, d) { return Math.max(m, d[0], d[1]); }, 1);
    var scale = 20 / biggest;
    list.forEach(function (d) {
      var thumb = '<span class="pfo-thumb"><i style="width:' + Math.max(3, Math.round(d[0] * scale)) +
        'px;height:' + Math.max(3, Math.round(d[1] * scale)) + 'px"></i></span>';
      c.appendChild(chip(dispNum(d[0]) + ' × ' + dispNum(d[1]), d[0] === S.w && d[1] === S.h, function () {
        S.w = d[0]; S.h = d[1];
        syncSizeInputs();
        update();
      }, thumb));
    });
  }

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function specTitle() {
    var f = S.finish === 'float-frame' ? 'stretched and framed in ' + frameDef().label.toLowerCase()
      : S.finish === 'paper-frame' ? 'framed in ' + frameDef().label.toLowerCase()
        : S.finish === 'stretched' ? 'stretched' : 'rolled';
    var bd = (isPaper() && S.border) ? ', ' + S.border + ' mm border' : '';
    return medium().label + ', ' + f + ', ' + S.w + ' x ' + S.h + ' mm' + bd;
  }

  function update() {
    var ok = validSize();
    var v = ok ? variantFor() : null;

    $('.pfo-size-label').textContent = dispSize(S.w, S.h);

    var face = faceMm();
    $('.pfo-profile').textContent =
      S.finish === 'float-frame' ? frameDef().label + ', ' + FLOAT_FACE + ' mm face, ' + FLOAT_GAP + ' mm shadow gap'
        : S.finish === 'paper-frame' ? face + ' × 40 mm ' + frameDef().label.toLowerCase() + ' moulding'
          : S.finish === 'stretched' ? CANVAS_DEPTH + ' mm stretcher, image wraps the edge' : '';

    var sn = $('.pfo-size-note');
    sn.hidden = ok;
    if (!ok) {
      sn.classList.add('is-bad');
      var u = ' ' + S.unit;
      sn.textContent =
        Math.min(S.w, S.h) < LIMITS.minSide ? 'Each side needs to be at least ' + dispNum(LIMITS.minSide) + u + '.'
          : Math.min(S.w, S.h) > LIMITS.maxShort ? 'The short side can be up to ' + dispNum(LIMITS.maxShort) + u + '.'
            : Math.max(S.w, S.h) > LIMITS.maxLong ? 'The long side can be up to ' + dispNum(LIMITS.maxLong) + u + '.'
              : 'The border leaves too little picture.';
    } else {
      sn.classList.remove('is-bad');
      sn.textContent = '';
    }

    // Same sentence, numbers in whichever unit is showing.
    $('.pfo-border-note').textContent =
      'The white border sits inside the size you order. A ' + dispNum(500) + ' × ' + dispNum(500) +
      ' print with a ' + dispNum(50) + ' ' + S.unit + ' border shows the picture at ' +
      dispNum(400) + ' × ' + dispNum(400) + '.';

    renderPresets();

    var q = qualityLevel(), res = $('.pfo-quality'), txt = '';
    var cls = 'is-ok';
    if (q === 'none') { txt = 'Upload a picture and we check the quality against the size you pick.'; }
    else if (q === 'low') { cls = 'is-bad'; txt = 'Low quality at this size. Your picture needs more detail, so try a smaller size or crop in less.'; }
    else if (q === 'medium') { cls = 'is-warn'; txt = 'Medium quality at this size. Fine from a step back, a touch soft up close.'; }
    else { txt = 'High quality at this size.'; }
    res.className = 'pfo-quality ' + cls;
    $('.pfo-quality-text').textContent = txt;
    $('.pfo-ack-wrap').hidden = q !== 'medium';

    var haveFile = !!S.img;
    var uploadOk = !UPLOAD || S.uploadState === 'ready';
    var canAdd = ok && v && haveFile && q !== 'low' && (q !== 'medium' || S.ack) && uploadOk && !S.adding;

    $('.pfo-price').textContent = v ? money(v.cents) : '—';
    $('.pfo-price-meta').textContent = v
      ? (DISPATCH ? 'inc GST · ' + DISPATCH : 'inc GST')
      : 'set a valid size';

    var btn = $('.pfo-add');
    btn.disabled = !canAdd;
    btn.textContent = S.adding ? 'Adding…'
      : !haveFile ? 'Upload a picture first'
        : (UPLOAD && S.uploadState === 'uploading') ? 'Sending your file ' + S.uploadPct + '%'
          : (UPLOAD && S.uploadState === 'error') ? 'Upload failed, try again'
            : 'Add to cart';

    if (!UPLOAD) {
      $('.pfo-preview-mode').hidden = false;
      btn.disabled = true;
      btn.textContent = 'Preview only';
    }

    draw();
  }

  /* --------------------------------------------------------------- inputs */

  $('.pfo-w').addEventListener('input', function (e) { S.w = toMm(parseFloat(e.target.value) || 0); update(); });
  $('.pfo-h').addEventListener('input', function (e) { S.h = toMm(parseFloat(e.target.value) || 0); update(); });
  // Rotate turns the PIECE, not the picture. A landscape order becomes portrait
  // and the photo stays upright, so nobody has to turn their phone sideways.
  $('.pfo-rotate').addEventListener('click', function () {
    var t = S.w; S.w = S.h; S.h = t;
    syncSizeInputs();
    update();
  });

  // Unit toggle. Nothing but the display changes, so the size in mm is untouched.
  root.querySelectorAll('.pfo-unit').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.dataset.unit === S.unit) return;
      S.unit = b.dataset.unit;
      root.querySelectorAll('.pfo-unit').forEach(function (o) {
        o.setAttribute('aria-pressed', String(o.dataset.unit === S.unit));
      });
      syncSizeInputs();
      syncBorderInput();
      if (isPaper()) renderBorders();
      update();
    });
  });
  $('.pfo-cb').addEventListener('input', function (e) { S.border = Math.max(0, toMm(parseFloat(e.target.value) || 0)); update(); });
  $('.pfo-zoom').addEventListener('input', function (e) { S.zoom = parseFloat(e.target.value); update(); });
  // Reset puts the crop back to the middle at full frame. It leaves the size alone,
  // because someone who typed a size does not expect a crop control to undo it.
  $('.pfo-recentre').addEventListener('click', function () {
    S.ox = 0.5; S.oy = 0.5; S.zoom = 1; $('.pfo-zoom').value = 1; update();
  });
  $('.pfo-ack').addEventListener('change', function (e) { S.ack = e.target.checked; update(); });

  /* ------------------------------------------------- fullscreen preview */

  function setFull(on) {
    root.classList.toggle('is-full', on);
    document.documentElement.classList.toggle('pfo-noscroll', on);
    document.body.classList.toggle('pfo-noscroll', on);
    $('.pfo-expand').hidden = on;
    $('.pfo-close').hidden = !on;
    // Fullscreen sizes the canvas from CSS, so drop the height draw() set inline.
    if (on) cv.style.height = '';
    // Let the layout settle before measuring the new box.
    requestAnimationFrame(function () { requestAnimationFrame(draw); });
  }

  $('.pfo-expand').addEventListener('click', function () { setFull(true); });
  $('.pfo-close').addEventListener('click', function () { setFull(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-full')) setFull(false);
  });

  // With nothing loaded, the frame itself is the upload button.
  cv.addEventListener('click', function () {
    if (!S.img) $('.pfo-file').click();
  });

  var drag = null;
  cv.addEventListener('pointerdown', function (e) {
    if (!S.img) return;
    drag = { x: e.clientX, y: e.clientY, ox: S.ox, oy: S.oy };
    cv.setPointerCapture(e.pointerId);
    cv.classList.add('is-dragging');
  });
  cv.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var c = cropRect();
    var slackX = (1 - c.w) * c.iw, slackY = (1 - c.h) * c.ih;
    // Real scale from the last draw, against the print area the picture fills.
    var pxPerSrc = (printArea().w * PPM) / (c.w * c.iw);
    if (slackX > 0) S.ox = Math.max(0, Math.min(1, drag.ox - (e.clientX - drag.x) / (slackX * pxPerSrc)));
    if (slackY > 0) S.oy = Math.max(0, Math.min(1, drag.oy - (e.clientY - drag.y) / (slackY * pxPerSrc)));
    update();
  });
  ['pointerup', 'pointercancel'].forEach(function (t) {
    cv.addEventListener(t, function () { drag = null; cv.classList.remove('is-dragging'); });
  });

  /* --------------------------------------------------------------- upload */

  $('.pfo-file').addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0];
    if (!f) return;
    S.file = f;
    S.imgName = f.name;
    S.rot = 0; S.zoom = 1; S.ox = 0.5; S.oy = 0.5; S.ack = false;
    S.fileToken = ''; S.uploadState = 'none'; S.uploadPct = 0;
    $('.pfo-zoom').value = 1;
    $('.pfo-ack').checked = false;

    var url = URL.createObjectURL(f);
    var im = new Image();
    im.onload = function () {
      var max = 2400;
      var sc = Math.min(1, max / Math.max(im.naturalWidth, im.naturalHeight));
      var c = document.createElement('canvas');
      c.width = Math.round(im.naturalWidth * sc);
      c.height = Math.round(im.naturalHeight * sc);
      c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
      S.img = c;
      S.srcPx = [im.naturalWidth, im.naturalHeight];
      $('.pfo-file-meta').textContent = f.name + ' · ' + im.naturalWidth + ' × ' +
        im.naturalHeight + ' px · ' + (f.size / 1048576).toFixed(1) + ' MB';
      URL.revokeObjectURL(url);
      matchPictureSize();
      startUpload();
    };
    im.onerror = function () {
      URL.revokeObjectURL(url);
      $('.pfo-file-meta').textContent = 'We could not read that file. Try a JPEG or PNG.';
    };
    im.src = url;
  });

  // Snap the size to the biggest suggestion that still reads High quality.
  function matchPictureSize() {
    var list = suggestSizes();
    if (!list.length) { update(); return; }
    var pick = list[0];
    for (var i = 0; i < list.length; i++) {
      S.w = list[i][0]; S.h = list[i][1];
      if (qualityLevel() === 'high') pick = list[i];
    }
    S.w = pick[0]; S.h = pick[1];
    syncSizeInputs();
    update();
  }

  // Resumable upload straight into DP-Fulfil's bucket. Contract:
  //   POST <endpoint>  {filename,size,type} -> {token, upload_url, method:"tus", headers, chunk_size}
  function startUpload() {
    if (!UPLOAD || !S.file) { update(); return; }
    S.uploadState = 'uploading'; S.uploadPct = 0; update();

    fetch(UPLOAD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ filename: S.file.name, size: S.file.size, type: S.file.type })
    })
      .then(function (r) { if (!r.ok) throw new Error('upload start failed'); return r.json(); })
      .then(function (j) {
        S.fileToken = j.token;
        return tusUpload(sameOrigin(j.upload_url), j.headers || {}, j.chunk_size || 6291456, S.file, function (pct) {
          S.uploadPct = pct; update();
        });
      })
      .then(function () { S.uploadState = 'ready'; update(); })
      .catch(function () { S.uploadState = 'error'; update(); });
  }

  // CHANGED 14 Sep: the create call hands back an ABSOLUTE upload_url on the
  // app's own myshopify host. From this storefront that is cross-origin, so the
  // PATCH dies at CORS before it leaves the browser and the only symptom is a
  // bare "Failed to fetch". Keep the path, drop their host, and the chunks go
  // back through this shop's signed app proxy where the create call already
  // works. Harmless if they later return a relative path.
  function sameOrigin(u) {
    try {
      var a = new URL(u, location.origin);
      return a.origin === location.origin ? u : a.pathname + a.search;
    } catch (e) { return u; }
  }

  function tusUpload(url, headers, chunkSize, file, onProgress) {
    var offset = 0;
    function sendChunk() {
      if (offset >= file.size) return Promise.resolve();
      var end = Math.min(offset + chunkSize, file.size);
      var h = { 'Tus-Resumable': '1.0.0', 'Upload-Offset': String(offset), 'Content-Type': 'application/offset+octet-stream' };
      Object.keys(headers).forEach(function (k) { h[k] = headers[k]; });
      return fetch(url, { method: 'PATCH', headers: h, body: file.slice(offset, end) })
        .then(function (r) {
          if (!r.ok) throw new Error('chunk failed');
          var next = parseInt(r.headers.get('Upload-Offset'), 10);
          offset = isNaN(next) ? end : next;
          onProgress(Math.round(offset / file.size * 100));
          return sendChunk();
        });
    }
    return sendChunk();
  }

  /* -------------------------------------------------------------- add to cart */

  $('.pfo-add').addEventListener('click', function () {
    var v = variantFor();
    if (!v || S.adding) return;
    S.adding = true; update();

    var c = cropRect();
    var props = {
      '_dpf_v': String(CFG.schemaVersion || 1),
      '_dpf_source': 'print-and-frame-online',
      '_dpf_medium': S.medium,
      '_dpf_finish': S.finish,
      '_dpf_frame': (S.finish === 'rolled' || S.finish === 'stretched') ? 'none' : S.frame,
      '_dpf_w': String(S.w),
      '_dpf_h': String(S.h),
      '_dpf_border': String(borderMm()),
      '_dpf_file': S.fileToken ? 'dpf:' + S.fileToken : '',
      '_dpf_file_name': S.imgName,
      '_dpf_px': S.srcPx[0] + 'x' + S.srcPx[1],
      '_dpf_crop': [c.x.toFixed(4), c.y.toFixed(4), c.w.toFixed(4), c.h.toFixed(4), S.rot].join(','),
      '_dpf_fit': 'cover',
      '_dpf_dpi': String(dpi()),
      'Print size': S.w + ' x ' + S.h + ' mm',
      'Surface': medium().label
    };
    if (qualityLevel() === 'medium' && S.ack) props['_dpf_dpi_ack'] = '1';
    if (isPaper() && borderMm()) props['Border'] = borderMm() + ' mm';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart'; })
      .catch(function () {
        S.adding = false;
        update();
        $('.pfo-cart-error').hidden = false;
      });
  });

  /* ----------------------------------------------------------------- boot */

  renderSurface();
  renderFinish();
  syncSizeInputs();
  syncBorderInput();
  update();
  measureHeader();
  draw();
  window.addEventListener('resize', function () { measureHeader(); draw(); });
  window.addEventListener('load', function () { measureHeader(); draw(); });
})();